import React, { useState, useEffect } from "react";
import "./Projects.css";
import api from "../../Api.js";
import ImageandvideoSlider from "../../ExtraComponent/ImageandvideoSlider.jsx";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [propertyGallery, setPropertyGallery] = useState([]);

  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);

  /* 🔹 Fetch projects */
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await api.get("real-estate-property");
        setProjects(res.data?.data || []);
      } catch (err) {
        console.error("Project fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  /* 🔹 Fetch gallery */
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await api.get("real-estate/gallery");
        setGalleryImages(res.data?.data || []);
      } catch (err) {
        console.error("Gallery fetch error:", err);
      }
    };

    fetchGallery();
  }, []);

  /* 🔹 Only ongoing projects */
  const filteredProjects = projects.filter(
    (item) => item.status === "Ongoing"
  );

  /* 🔹 Handle project click */
  const handleGallery = (project) => {
    if (!galleryImages.length) return;

    const filtered = galleryImages.filter(
      (item) => item.property_name === project.property_name
    );

    if (filtered.length === 0) {
      console.warn("No media found for", project.property_name);
      return;
    }

    setPropertyGallery(filtered);
    setOpen(true); // ✅ OPEN SLIDER
  };

  return (
    <div className="projects-section" id="projects">
      {/* 🔹 Image & Video Slider */}
      <ImageandvideoSlider
        open={open}
        setOpen={setOpen}
        media={propertyGallery}
      />

      <h2 className="projects-title">Our Projects</h2>
      <p className="projects-subtitle">
        Discover our portfolio of premium residential and commercial properties.
      </p>

      {/* 🔹 Filter (static for now) */}
      <div className="projects-filter">
        <button className="projects-filter-btn active-filter">
          Ongoing Projects
        </button>
      </div>

      {/* 🔹 Projects Grid */}
      <div className="projects-grid">
        {loading ? (
          <p className="loading-text">Loading projects...</p>
        ) : filteredProjects.length === 0 ? (
          <p className="no-projects">No projects found</p>
        ) : (
          filteredProjects.map((project) => (
            <div
              key={project.id}
              className="project-card"
              onClick={() => handleGallery(project)}
            >
              <img
                src={project.property_image_url}
                alt={project.property_name}
                className="project-image"
              />

              <span className={`project-badge ${project.status}`}>
                {project.status.toUpperCase()}
              </span>

              <div className="project-info">
                <h3 className="project-title">
                  {project.property_name}
                </h3>
                <p className="project-location">
                  {project.location}
                </p>
              </div>
            </div>
          ))
        )}
      </div>

      {/* 🔹 CTA */}
      <h2 className="wpkg-title" style={{ marginTop: "3rem" }}>
        Find Your Dream Property Today
      </h2>

      <p className="wpkg-subtitle">
        Contact us to schedule a site visit and learn more about our exclusive
        offers and upcoming projects.
      </p>

      <button className="wpkg-book-btn">Schedule a Visit</button>
    </div>
  );
};

export default Projects;
